import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';

import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { purchaseVSsold } from '../../helpers/api';

function SimpleBarChart() {

    const data = [
        {
            day: 'Monday',
            uv: 4000,
            pv: 2400,
            amt: 2400,
        },
        {
            day: 'Tuesday',
            uv: 3000,
            pv: 1398,
            amt: 2210,
        },
        {
            day: 'Wednesday',
            uv: 2000,
            pv: 9800,
            amt: 2290,
        },
        {
            day: 'Thursday',
            uv: 2780,
            pv: 3908,
            amt: 2000,
        },
        {
            day: 'Friday',
            uv: 1890,
            pv: 4800,
            amt: 2181,
        },
        {
            day: 'Saturday',
            uv: 2390,
            pv: 3800,
            amt: 2500,
        },
        {
            day: 'Sunday',
            uv: 3490,
            pv: 4300,
            amt: 2100,
        },
    ];

    // const [data, setData] = useState([])

    // const getData = async () => {
    //     try {
    //         const response = await purchaseVSsold()
    //         console.log("PVS", response);
    //         setData(response.message)
    //     }
    //     catch (e) {
    //         console.log(e);
    //     }
    // }

    // useEffect(() => {
    //     getData()
    // }, [])


    return (
        <>
            <div style={{ height: "300px" }}>
                <ResponsiveContainer className="SimpleArea_BarChart" width={"100%"} height="100%">
                    <BarChart
                        width={900}
                        height={250}
                        data={data}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="day" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="pv" fill="#8F43EE" />
                        <Bar dataKey="uv" fill="#E7D4FF" />
                    </BarChart>
                </ ResponsiveContainer>
            </div>
        </>
    )
}

export default SimpleBarChart
